<template>
  <a-card :title="$t('product.bulk_publish.title')" :bordered="false">
    <p class="mt-4">
      {{ $t('product.bulk_publish.easy_way_desc') }}
    </p>
  </a-card>
</template>
  
  <script>
  import { downloadFile, uploadFile } from '@/api/product'
  
  export default {
    name: 'ImportProductPage',
    data() {
      return {
      }
    },
    methods: {
    },
  }
  </script>
  
  <style lang="scss">
  </style>